import React, { MouseEvent } from 'react';
import { Box, Typography } from '@mui/material';
import { IChatsRecord } from '../../../../interfaces/chats';
import { EventTypeFilterEnum } from '../../../../constants/enums';
import { getEventMetaPill, hasUnreadChat } from '../../../../utils/messaging/chatListState';
import LineHourglassSvg from '../../../../assets/svg-fc/LineHourglassSvg';
import LineDotsSvg from '../../../../assets/svg-fc/LineDotsSvg';
import LineChevronSvg from '../../../../assets/svg-fc/LineChevronSvg';
import './eventHeader.scss';

interface EventHeaderProps {
  event: IChatsRecord;
  isExpanded: boolean;
  isMenuOpen?: boolean;
  onMoreClick?: (event: MouseEvent<HTMLElement>) => void;
}

const EVENT_TYPE_CLASS: Record<EventTypeFilterEnum, string> = {
  [EventTypeFilterEnum.B2C]: 'eventTypeB2C',
  [EventTypeFilterEnum.B2B]: 'eventTypeB2B',
  [EventTypeFilterEnum.Prepaid]: 'eventTypePrepaid',
};

const EventHeader: React.FC<EventHeaderProps> = ({ event, isExpanded, isMenuOpen, onMoreClick }) => {
  const parts = event.dateBadge.split(' ');
  const monthAbbr = parts[0] || '';
  const dayNumber = parts[1] || '';
  const pill = getEventMetaPill(event);
  const unreadChats = event.chats.filter(hasUnreadChat).length;

  return (
    <Box className="eventAccordionHeader">
      <Box className="dateBadge">
        <Box className="dateBadgeTop">{monthAbbr}</Box>
        <Box className="dateBadgeBottom">{dayNumber}</Box>
      </Box>
      <Box className="eventInfo">
        <Typography className="eventName">{event.eventName}</Typography>
        <Box className="eventBadges">
          <Box className={`eventMetaPill eventMetaPill--${pill.kind}`}>
            {pill.kind === 'inProgress' ? (
              <span className="eventMetaPillDot" aria-hidden />
            ) : (
              <LineHourglassSvg size={12} />
            )}
            <Typography component="span">{pill.label}</Typography>
          </Box>
          <Box className={`eventTypeBadge ${EVENT_TYPE_CLASS[event.eventType] ?? ''}`}>
            <span className="eventTypeDot" aria-hidden />
            <Typography component="span">{event.eventType}</Typography>
          </Box>
        </Box>
      </Box>
      <Box className="eventHeaderTrailing">
        {!isExpanded && unreadChats > 0 ? (
          <Box className="eventUnreadCount">
            <Typography component="span">{unreadChats}</Typography>
          </Box>
        ) : null}
        {onMoreClick ? (
          <Box
            component="button"
            type="button"
            aria-label={`More actions for ${event.eventName}`}
            aria-haspopup="menu"
            aria-expanded={Boolean(isMenuOpen)}
            className={`eventMoreButton ${isMenuOpen ? 'open' : ''}`}
            onClick={(clickEvent: MouseEvent<HTMLElement>) => {
              clickEvent.stopPropagation();
              onMoreClick(clickEvent);
            }}
          >
            <LineDotsSvg size={18} />
          </Box>
        ) : null}
        <Box className="eventChevron">
          <LineChevronSvg direction={isExpanded ? 'up' : 'down'} />
        </Box>
      </Box>
    </Box>
  );
};

export default EventHeader;
